<template>
    <dialog
        ref="dialogRef"
        class="my-tickets-popup"
        body-scrollable
        v-on-click-outside="onClickOutsideHandler"
        open
        v-if="popupOpen"
    >
        <MyTicketsContent />
        <Button
            @click="closePopup"
            :component="DynamicLink as any"
            :path="PATHS.MY_TICKETS"
            type="tertiary"
            class="my-tickets-popup__footer"
        >
            Přejít na moje tikety
            <template #icon-right>
                <SvgIcon name="arrow-right" />
            </template>
        </Button>
    </dialog>
</template>

<script lang="ts" setup>
import { ref } from "vue";
import { vOnClickOutside } from "@vueuse/components";

import SvgIcon from "@/shared/components/atoms/SvgIcon.vue";
import Button from "@/shared/components/atoms/Button.vue";
import MyTicketsContent from "@/my-tickets/components/organisms/MyTicketsContent.vue";
import DynamicLink from "@/shared/components/atoms/DynamicLink.vue";

import { PATHS } from "@/router/paths";

const popupOpen = defineModel<boolean>();

const dialogRef = ref<HTMLDialogElement>(null);

const closePopup = () => {
    popupOpen.value = false;
};

const onClickOutsideHandler = [
    () => {
        closePopup();
    },
    { ignore: [".main-header-button--tickets"] },
] as any;
</script>
